import styled from 'styled-components'

import { COLORS } from '@probatix/common/constants/colors'
import { MOBILE_WIDTH } from '@probatix/common/constants/design'

import { BoxProps } from './Box.model'

export const StyledBox = styled.div<BoxProps>`
  padding: 12px;
  background: ${COLORS.WHITE};
  position: relative;
  border-radius: 25px;
  width: max-content;
  padding-right: 30px;
  
  ${({ center }) => center && `
    margin: auto;
  `}

  ${({ background }) => background && `
    background: ${background};
    overflow: hidden;
  `}

  ${({ background }) => background && `
    background: ${background};
    overflow: hidden;
  `}

  ${({ radius }) => radius && `
    border-radius: ${radius}px;
  `}

  ${({ width }) => width && `
    width: ${width};
  `}

  ${({ minHeight }) => minHeight && `
    min-height: ${minHeight};
  `}

  ${({ cursor }) => cursor && `
    cursor: ${cursor};
  `}
  
  @media(max-width: ${MOBILE_WIDTH}px) {
    border: 0 !important;
    box-shadow: none;
  }
`
